/** Small view helpers shared by pages. */

/** API timestamps are UTC; tolerate ones without an offset (SQLite in dev). */
export const parseTs = (iso) => new Date(/[zZ]|[+-]\d\d:\d\d$/.test(iso) ? iso : `${iso}Z`)

export function timeAgo(iso, lang) {
  if (!iso) return null
  const seconds = (parseTs(iso).getTime() - Date.now()) / 1000
  const rtf = new Intl.RelativeTimeFormat(lang, { numeric: 'auto', style: 'short' })
  const abs = Math.abs(seconds)
  if (abs < 60) return rtf.format(Math.min(0, Math.round(seconds)), 'second')
  if (abs < 3600) return rtf.format(Math.round(seconds / 60), 'minute')
  if (abs < 86400) return rtf.format(Math.round(seconds / 3600), 'hour')
  return rtf.format(Math.round(seconds / 86400), 'day')
}

export function isToday(iso) {
  return parseTs(iso).toDateString() === new Date().toDateString()
}

export const pct = (v) => (v == null ? null : `${Math.round(v)}%`)
